var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.readOnly)?_c('read-only-meeting-form'):_c('main',{staticClass:"max-w-5xl m-5 mb-10 w-full"},[_c('meeting-form',{attrs:{"meeting-id":_vm.meeting.id}}),_c('app-quick-actions',{attrs:{"options":_vm.quickActions},on:{"choose":function($event){return $event.run()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }